import { getBrowserLanguage } from "common/Support";

const firstDayOfWeekMap = [
    {
        day: 1,
        territories: [
            "001",
            "AD",
            "AI",
            "AL",
            "AM",
            "AN",
            "AR",
            "AT",
            "AX",
            "AZ",
            "BA",
            "BE",
            "BG",
            "BM",
            "BN",
            "BY",
            "CH",
            "CL",
            "CM",
            "CR",
            "CY",
            "CZ",
            "DE",
            "DK",
            "EC",
            "EE",
            "ES",
            "FI",
            "FJ",
            "FO",
            "FR",
            "GB",
            "GE",
            "GF",
            "GP",
            "GR",
            "HR",
            "HU",
            "IE",
            "IS",
            "IT",
            "KG",
            "KZ",
            "LB",
            "LI",
            "LK",
            "LT",
            "LU",
            "LV",
            "MC",
            "MD",
            "ME",
            "MK",
            "MN",
            "MQ",
            "MY",
            "NL",
            "NO",
            "NZ",
            "PL",
            "RE",
            "RO",
            "RS",
            "RU",
            "SE",
            "SI",
            "SK",
            "SM",
            "TJ",
            "TM",
            "TR",
            "UA",
            "UY",
            "UZ",
            "VA",
            "VN",
            "XK",
        ],
    },
    { day: 5, territories: ["MV"] },
    {
        day: 6,
        territories: ["AE", "AF", "BH", "DJ", "DZ", "EG", "IQ", "IR", "JO", "KW", "LY", "OM", "QA", "SD", "SY"],
    },
    {
        day: 0,
        territories: [
            "AG",
            "AS",
            "AU",
            "BD",
            "BR",
            "BS",
            "BT",
            "BW",
            "BZ",
            "CA",
            "CN",
            "CO",
            "DM",
            "DO",
            "ET",
            "GT",
            "GU",
            "HK",
            "HN",
            "ID",
            "IL",
            "IN",
            "JM",
            "JP",
            "KE",
            "KH",
            "KR",
            "LA",
            "MH",
            "MM",
            "MO",
            "MT",
            "MX",
            "MZ",
            "NI",
            "NP",
            "PA",
            "PE",
            "PH",
            "PK",
            "PR",
            "PT",
            "PY",
            "SA",
            "SG",
            "SV",
            "TH",
            "TT",
            "TW",
            "UM",
            "US",
            "VE",
            "VI",
            "WS",
            "YE",
            "ZA",
            "ZW",
        ],
    },
];

export function getFirstDayOfWeek(): number {
    return firstDayOfWeekMap.find(d => d.territories.find(t => getBrowserLanguage()?.endsWith(t) === true))?.day ?? 0;
}
